import * as angular from "angular";
import {IController} from "angular";

export class SitesLeanTableRowCtrl implements IController {
  sitesLeanTableCtrl: IController;
  sites: any;

  constructor() {
  }
}

angular
  .module('bringoz.admin.organizations')
  .component('sitesLeanTableRow', {
    require: {
      sitesLeanTableCtrl: '^sitesLeanTable'
    },
    bindings: {
      site: '<'
    },
    template: require('./sites-lean-table-row.html').default,
    controller: SitesLeanTableRowCtrl
  });
